import MultiOptionQuestions from "./children/MultipleOptionQuestions"
import MatrixQuestions from "./children/MatrixQuestions"
import DemographicsQuestion from "./children/DemographicsQuestion"
import DescriptiveSection from "./children/DescriptiveSection"
import OpenEndedQuestions from "./children/OpenEndedQuestions"
import React from "react"
import FinalPage from "./children/FinalPage"
import TranslationSection from "./children/TranslationSection"
import RankingQuestion from "./children/RankingQuestion"
import RatingScaleQuestion from "./children/RatingScaleQuestion"
import TableMatrix from "./children/TableMatrix"
import NetPromoterScore from "./children/NetPromoterScore"
import FeedBackRanking from "./children/FeedBackRanking"
import FeedbackTextEntry from "./children/FeedbackTextEntry"

export const getComponent = (type, props) => {
    let components = getChildren({ ...props })
    return components[type]
}

const getChildren = (props) => {
    return (
        {
            "matrix": <TableMatrix {...props} />,
            "descriptive": <DescriptiveSection {...props} />,
            "textEntry": <OpenEndedQuestions {...props} />,
            "multipleChoice": <DemographicsQuestion {...props} />,
            "multipleOption": <MultiOptionQuestions {...props} />,
            "Final Page": <FinalPage {...props} />,
            "Translation Page": <TranslationSection {...props} />,
            "yesOrNo": <DemographicsQuestion {...props} />,
            "ranking": <RankingQuestion {...props} />,
            "ratingScale": <RatingScaleQuestion {...props} />,
            "likert": <MatrixQuestions {...props} />,
            "employerNetPromoterScore": <NetPromoterScore {...props} />,
            "priorityDrag": <FeedBackRanking {...props} />,
            "priorityComments": <FeedbackTextEntry {...props} />,
        }

    )
}

export default {
    FINAL_PAGE: "Final Page",
    TRANSLATION_PAGE: "Translation Page",
}

export const KEY_CONSTANTS = {
    CONTINUE_BUTTON: 'continue',
    SUBMIT_SURVEY_MODAL: "surveyCompletedMessage",
    FINAL_PAGE_SUBMIT_TEXT: "surveySubmitMessage",
    SURVEY_PREVIEW_END: "surveyPreviewEndMessage",
    SURVEY_UNANSWERED_MESSAGE: "surveyUnansweredMessage",
    PLACEHOLDER_LABEL: "placeholder",
    TRANSLATED_DESCRIPTION: "translatedDescription",
    HTML_TEXT: "HTMLText",
    NORMAL_TEXT: "text",
    LABEL: "label",
    QUESTION: "question",
    HTML_QUESTION: "HTMLQuestion",
    BACK_TO_SURVEY: "back",
    SUBMIT_TEXT: "submit",
    HTML_QUESTION_SELF : "HTMLSelfQuestion",
    SELF_QUESTION:"selfQuestion",
    SELF:"self"
}